module.exports = __webpack_public_path__ + "img/nys-wbs.dc679223.png";